import { Bank } from '@/features/dashboard/rawBankTransactions/types/Bank.ts';

export const bankLabels: Record<Bank, string> = {
  [Bank.MBANK]: 'mBank',
  [Bank.ING]: 'ING',
  [Bank.NEST_BANK]: 'Nest Bank',
  [Bank.OTHER_PL]: 'Inny (Polski)',
};

export const getBankLabel = (bank: string): string =>
  bankLabels[bank as Bank] ?? bank;

export const bankOptions = Object.values(Bank).map((value) => ({
  value,
  label: bankLabels[value],
}));
